import type { WeekScores } from '@CS/components/Popups';
import deepFreeze from '@CS/utils/deepFreeze';
import { randomInt } from '@CS/utils/Number';

export const CURRENT_WEEK = 4;

export const getWeekScores: WeekScores = (week: number) =>
  new Promise((resolve) =>
    setTimeout(
      resolve.bind(null, {
        weekScores: weekScores[week],
        userData: userData[week]
      }),
      randomInt(1e2, 1e3)
    )
  );

const weekScores = deepFreeze(
  [...Array(CURRENT_WEEK)].map(() =>
    [...Array(10)]
      .map(() => ({
        name: `${
          String.fromCharCode(randomInt(65, 90)) +
          String.fromCharCode(randomInt(65, 90)) +
          String.fromCharCode(randomInt(65, 90))
        }`,

        score: randomInt(1000, 9999)
      }))
      .sort((prev, next) => next.score - prev.score)
  )
);

const userData = deepFreeze(
  [...Array(CURRENT_WEEK)].map(() => ({
    name: 'DoomSlayer',
    score: randomInt(100, 999),
    position: randomInt(10, 99)
  }))
);
